import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";
import UserModel from "../models/UserModel";
import Modifiers from "../models/Modifiers";
import CommentModel from "../models/CommentModel";

export default class ReplyHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "reply/value":
                return this.handleValue(model, params);
            case "reply/submit":
                return this.handleSubmit(model, params);
            case "reply/result":
                return this.handleResult(model, params);
            case "reply/error":
                return this.handleError(model, params);
            case "reply/toggle":
                return this.handleToggle(model, params);
            case "reply/hide":
                return this.handleHide(model, params);
            default:
                return model;
        }
    }

    private handleResult(model: DiscussionModel, data: any): DiscussionModel {

        data.children = false;
        data.user = data.user ? new UserModel(data.user) : null;

        model = Modifiers.setReplySending(model, data.parent_id, false);
        model = Modifiers.appendCommentAfter(model, new CommentModel(data), data.parent_id);

        if (model.getUser() && !model.getUser().isVerified()) {
            model = model.showModalVerify();
        }

        return model;
    }

    private handleError(model: DiscussionModel, commentId: number): DiscussionModel {
        this.dispatch("error", 2);
        model = Modifiers.setReplySending(model, commentId, false);
        return model;
    }

    private handleValue(model: DiscussionModel, params: {
        comment: number;
        value: string;
    }): DiscussionModel {
        model = model.setReplyValue(params.comment, params.value);
        return model;
    }

    private handleSubmit(model: DiscussionModel, commentId: number): DiscussionModel {

        const comment = model.getComment(commentId);

        if (comment) {
            if (comment.getReplyValue() != "" && comment.isReplySending() != true) {
                if (model.getUser()) {
                    const user = model.getUser();
                    if (!model.isPremium() || user.hasPremium() || user.isEditor()) {
                        model = Modifiers.setReplySending(model, commentId, true);
                        this.fetch("create", {
                            project: model.getProject(),
                            discussion: model.getDiscussion(),
                            comment: comment.getCommentId(),
                            content: comment.getReplyValue(),
                        }).then((response) => {
                            if (response.result) {
                                this.dispatch("reply/hide", commentId);
                                this.dispatch("reply/result", response.result);
                            } else {
                                this.dispatch("reply/error", commentId);
                            }
                        }).catch((error) => {
                            this.dispatch("reply/error", commentId);
                        });
                    } else {
                        this.dispatch("premium");
                    }
                } else {
                    this.dispatch("login", 1);
                }
            }
        }

        return model;

    }

    private handleHide(model: DiscussionModel, commentId: number): DiscussionModel {
        model = model.setReplyDisplay(commentId, false);
        model = model.setReplyValue(commentId, "");
        return model;
    }

    private handleToggle(model: DiscussionModel, commentId: number): DiscussionModel {

        const comment = model.getComment(commentId);

        if (comment) {
            if (model.getUser()) {
                model = model.setReplyDisplay(
                    comment.getCommentId(),
                    !comment.getReplyDisplay()
                );
            } else {
                this.dispatch("login", 1);
            }
        }

        return model;

    }

}